module.exports = __webpack_public_path__ + "static/img/index_bg_1.51a5d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_1.jpg
// module id = fOB5
// module chunks = 9